var map = {
	"./image-11.png": 61,
	"./image-12.png": 62,
	"./image-14.png": 63,
	"./image-15.png": 64,
	"./image-2.png": 65,
	"./image-3.png": 66,
	"./image-4.png": 67,
	"./image-5.png": 68,
	"./image-7.png": 69,
	"./image-8.png": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;